import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import EventIcon from "@material-ui/icons/Event";
import DateRangePicker from "@material-ui/lab/DateRangePicker";
import { Box } from "@material-ui/core";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";
import moment, { Moment } from "moment";
import { changeReportDate, changeStartDate } from "redux/user/userActions";

const DateRangeSelector = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const minDate = useSelector(
    (state: RootState) => state.portfolioInformation.data?.SalkkuAloitettu
  );

  const minDateString = moment.utc(minDate).toISOString();

  const maxDateString = moment
    .utc()
    .subtract(1, "day")
    .startOf("day")
    .toISOString();

  const startValue = useSelector((state: RootState) => state.user.startDate);

  const endValue = useSelector((state: RootState) => state.user.reportDate);

  return (
    <DateRangePicker
      mask="_._.____"
      startText={t("start_date")}
      endText={t("end_date")}
      minDate={minDateString}
      maxDate={maxDateString}
      value={[startValue, endValue]}
      inputFormat="D.M.YYYY"
      onChange={(newValue) => {
        const newDateRange = newValue.map((value) =>
          moment
            .utc(
              (value as unknown as Moment)?.format("MM-DD-YYYY"),
              "MM-DD-YYYY"
            )
            .toISOString()
        );

        dispatch(changeStartDate(newDateRange[0]));
        dispatch(changeReportDate(newDateRange[1]));
      }}
      renderInput={(startProps, endProps) => (
        <React.Fragment>
          <TextField
            {...startProps}
            variant="standard"
            helperText={undefined}
            InputProps={{
              ...startProps.InputProps,
              endAdornment: <EventIcon />,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box sx={{ mx: 2 }}></Box>
          <TextField
            {...endProps}
            variant="standard"
            helperText={undefined}
            InputProps={{
              ...endProps.InputProps,
              endAdornment: <EventIcon />,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </React.Fragment>
      )}
    />
  );
};

export default React.memo(DateRangeSelector);
